import styled from 'styled-components';
import { Button } from 'antd';

import { ArrowRightIcon } from '@/assets/icons/v2';
import { Container as NavigationContainer } from '@/components/ui/StepsNavigation/styles';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	padding: 2rem 3rem;
	background: ${({ theme }) => theme.palette.secondary[50]};
	border-radius: 1rem;
`;

export const NavButton = styled(Button)`
	display: flex;
	align-items: center;
	justify-content: center;
	width: auto;
	height: auto;
	padding: 0.5rem;
	background: ${({ theme }) => theme.palette.secondary.white};
	border: 1px solid ${({ theme }) => theme.palette.secondary[150]};
	border-radius: 0.25rem;
	color: ${({ theme }) => theme.palette.secondary[400]};
	box-shadow: none;

	&:hover,
	&:focus {
		background: ${({ theme }) => theme.palette.secondary.white};
		border-color: ${({ theme }) => theme.palette.primary[600]};
		color: ${({ theme }) => theme.palette.primary[600]};
	}
`;

export const NavArrow = styled(ArrowRightIcon)`
	display: block;
	width: 1.5rem;
	height: 1.5rem;
`;

export const PreviousArrow = styled(NavArrow)`
	transform: rotate(180deg);
`;

export const StepperWrapper = styled.div`
	${NavigationContainer} {
		padding: 0;
	}

	.step-number,
	.step-checked {
		background: ${({ theme }) => theme.palette.secondary.white};
	}

	.step-number {
		border-color: ${({ theme }) => theme.palette.secondary[250]};
		color: ${({ theme }) => theme.palette.secondary[250]};
	}
`;

export const StepKeyWrapper = styled.div`
	> .ant-row > .ant-col-22,
	> .ant-row > .ant-col-xs-22 {
		flex: 0 0 100%;
		max-width: 100%;
	}
`;
